import { Map } from "immutable";
import GenerateNextPosition from "views/logic/views/GenerateNextPosition";
import SetWidgetTitle from "views/logic/views/SetWidgetTitle";
const AddWidgetToDashboardTab = (widget, targetQueryId, dashboard, oldPosition, title) => {
  const dashboardQueryId = targetQueryId != null ? targetQueryId : dashboard.search.queries.first().id;
  const viewState = dashboard.state.get(dashboardQueryId);
  const widgets = viewState.widgets.push(widget);
  const { widgetPositions } = viewState;
  const newWidgetPositions = GenerateNextPosition(
    Map(widgetPositions),
    widgets.toArray(),
    oldPosition == null ? void 0 : oldPosition.height,
    oldPosition == null ? void 0 : oldPosition.width
  );
  const titlesMap = viewState.titles;
  const newTitlesMap = SetWidgetTitle(titlesMap, widget, title);
  const newViewState = viewState.toBuilder().widgets(widgets).titles(newTitlesMap).widgetPositions(newWidgetPositions).build();
  return dashboard.toBuilder().state(dashboard.state.set(dashboardQueryId, newViewState)).build();
};
export default AddWidgetToDashboardTab;
